import { render, staticRenderFns } from "./EmbeddedConfirm.vue?vue&type=template&id=26f1e05e&"
import script from "./EmbeddedConfirm.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports